import { PlayCircle, Film, Cake, ShieldCheck, EyeOff, CornerUpLeft } from 'lucide-react';

// Bump VERSION and edit ITEMS every time a new feature ships.
export const WHATS_NEW_VERSION = '2026.06.6';

export const WHATS_NEW = {
  icons: [PlayCircle, Film, Cake, ShieldCheck, EyeOff, CornerUpLeft],
  es: {
    title: 'Novedades en PAPO', subtitle: 'Esto es lo nuevo de esta actualización', ok: '¡Genial!', guide: 'Ver en la Guía',
    items: [
      ["Vídeos de YouTube, TikTok y más", "Pega el enlace en un post o chat y míralo dentro de PAPO."],
      ["Subida de vídeos más fiable", "Verás el porcentaje de optimización y tu vídeo se publica siempre."],
      ["Teléfono y cumpleaños", "Añádelos en Editar perfil y elige con el ojo: Público, Amigos o Solo yo."],
      ["Panel de privacidad", "En Ajustes > Privacidad ves de un vistazo quién ve cada dato tuyo."],
      ["Email oculto por defecto", "Nadie ve tu email salvo que lo muestres con el icono del ojo en tu perfil."],
      ["Responder mensajes", "Pulsa ↩ «Responder» junto a un mensaje para citarlo, en privado y en grupos."],
    ],
  },
  pt: {
    title: 'Novidades no PAPO', subtitle: 'Isto é o que há de novo nesta atualização', ok: 'Fixe!', guide: 'Ver no Guia',
    items: [
      ["Vídeos do YouTube, TikTok e mais", "Cola o link num post ou chat e vê-o dentro do PAPO."],
      ["Envio de vídeos mais fiável", "Vês a percentagem de otimização e o teu vídeo é sempre publicado."],
      ["Telefone e aniversário", "Adiciona-os em Editar perfil e escolhe com o olho: Público, Amigos ou Só eu."],
      ["Painel de privacidade", "Em Definições > Privacidade vês num relance quem vê cada dado teu."],
      ["Email oculto por defeito", "Ninguém vê o teu email a menos que o mostres com o ícone do olho no teu perfil."],
      ["Responder mensagens", "Toca em ↩ «Responder» junto a uma mensagem para a citar, em privado e em grupos."],
    ],
  },
  en: {
    title: "What's new in PAPO", subtitle: "Here's what's new in this update", ok: 'Great!', guide: 'See in the Guide',
    items: [
      ["YouTube, TikTok videos and more", "Paste the link in a post or chat and watch it inside PAPO."],
      ["More reliable video uploads", "See the optimization percentage, and your video always gets published."],
      ["Phone and birthday", "Add them in Edit profile and choose with the eye: Public, Friends or Only me."],
      ["Privacy panel", "Settings > Privacy shows at a glance who sees each piece of your data."],
      ["Email hidden by default", "Nobody sees your email unless you show it with the eye icon on your profile."],
      ["Reply to messages", "Tap ↩ “Reply” next to a message to quote it, in private chats and groups."],
    ],
  },
  fr: {
    title: 'Nouveautés de PAPO', subtitle: 'Voici les nouveautés de cette mise à jour', ok: 'Super !', guide: 'Voir dans le Guide',
    items: [
      ["Vidéos YouTube, TikTok et plus", "Collez le lien dans un post ou un chat et regardez-la dans PAPO."],
      ["Envoi de vidéos plus fiable", "Vous voyez le pourcentage d’optimisation et votre vidéo est toujours publiée."],
      ["Téléphone et anniversaire", "Ajoutez-les dans Modifier le profil et choisissez avec l'œil : Public, Amis ou Moi uniquement."],
      ["Panneau de confidentialité", "Paramètres > Confidentialité montre en un coup d’œil qui voit chaque donnée."],
      ["E-mail masqué par défaut", "Personne ne voit votre e-mail sauf si vous l’affichez avec l’icône œil sur votre profil."],
      ["Répondre aux messages", "Touchez ↩ « Répondre » à côté d’un message pour le citer, en privé et en groupe."],
    ],
  },
};
